module.exports = __webpack_public_path__ + "1fb397dccdcbece8df402d9bf9a2e4de.MP3";